import React, { useEffect, useState, useTransition } from "react";
import DeleteIcon from "../../../assets/images/trash.svg";
import EditIcon from "../../../assets/images/Edit.svg";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getEcosystemMappingSectionDetails,
  postEcosystemMappingSectionDetails,
} from "../../../store/actions";
import { motion } from "motion/react";
import Select from "react-select";
import { url } from "../../../store/sagas/API.js";
import OtherImage from "../../../assets/images/Othericon.svg";

const EcMappingAddECSidebar = ({ onClose, childName, subSectionName }) => {
  const dispatch = useDispatch();
  const [biBelongsToData, setBiBelongsToData] = useState([]);
  const [targetSectorsData, setTargetSectorsData] = useState([]);
  const [selectedSectorType, setSelctedSectorType] = useState("");
  const [selectedSectorDataForEcosystem, setSelectedSectorDataForEcosystem] =
    useState([]);
  const [sectorDataForEcosystem, setSectorDataForEcosystem] = useState([]);
  const [sectorTypeData, setSectorTypeData] = useState([
    { label: "BI Sector", value: "BI Sector", icon: OtherImage },
    { label: "BI Target Sector", value: "BI Target Sector", icon: OtherImage },
  ]);
  useEffect(() => {
    dispatch(getEcosystemMappingSectionDetails(localStorage.getItem("bi_id")));
  }, []);
  const fetchEcosystemMappingSectionData = useSelector(
    (state) => state.fetchEcosystemMappingSectionData
  );
  const selectedPermission = useSelector((state) => state.selectedPermission);
  const BIcustomStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "95%",
      display: "inline-block",
      border: "1px solid #ccc",
      boxSizing: "border-box",
      paddingLeft: 0,
      borderRadius: "10px",
    }),
    menu: (provided) => ({
      ...provided,
      width: "95%",
    }),
    img: {
      height: 40,
    },
  };
  const customFilter = (option, searchText) => {
    if (option.data.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (fetchEcosystemMappingSectionData) {
      setTargetSectorsData(
        fetchEcosystemMappingSectionData?.target_sector_data?.map((obj) => {
          return {
            value: obj.value,
            label: obj.label,
            icon: obj.icon ? url + obj.icon : OtherImage,
          };
        })
      );
      setBiBelongsToData(
        fetchEcosystemMappingSectionData?.bi_belongs_to_data?.map((obj) => {
          return {
            value: obj.value,
            label: obj.label,
            icon: obj.icon ? url + obj.icon : OtherImage,
          };
        })
      );
    }
  }, [fetchEcosystemMappingSectionData]);
  useEffect(() => {
    if (selectedSectorType && selectedSectorType?.label === "BI Sector") {
      setSelectedSectorDataForEcosystem("");
      setSectorDataForEcosystem(biBelongsToData);
    } else if (
      selectedSectorType &&
      selectedSectorType?.label === "BI Target Sector"
    ) {
      setSelectedSectorDataForEcosystem("");
      setSectorDataForEcosystem(targetSectorsData);
    }
  }, [selectedSectorType]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault();
        handleSubmit();
      }

      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedSectorType,selectedSectorDataForEcosystem]);
  const handleSubmit = (e) => { 
    if (e) e.preventDefault();
    if (selectedSectorType && selectedSectorDataForEcosystem) {
      const formData = {
        sector_type: selectedSectorType.value,
        target_sector: selectedSectorDataForEcosystem.value,
      };

      console.log("Form Data:", formData);
      dispatch(
        postEcosystemMappingSectionDetails(
          localStorage.getItem("bi_id"),
          false,
          false,
          false,
          "addecosystem",
          false,
          formData
        )
      );
      onClose();
    }
  };

  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: 1 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
      className={"sidenav"}
    >
      <div
        className="gtm-sidebar-header"
        style={{
          borderBottom: "1px solid lightgrey",
          alignItems: "center",
        }}
      >
        <h6
          style={{
            flex: "1",
            minWidth: "70%",
            maxWidth: "80%",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            margin: "0",
            paddingTop: "4px",
            fontSize: "var(--sub-heading-font-size)",
            fontWeight: "var(--heading-font-weight)",
          }}
        >
          <span>
            {"Ecosystem Mapping"} &gt; {"Add Ecosystem"}
          </span>
        </h6>
        <a href="#" className="closebtn" onClick={onClose}>
          &times;
        </a>
      </div>
      <div className="gtm-sidebar-body">
        <div style={{ display: "flex", width: "100%" }}>
          <Form.Group style={{ width: "100%" }}>
            <Form.Label className="bi_details-title">
              Sector Type <span className="required">*</span>
            </Form.Label>
            <Select
              required
              name="selectedbitype"
              styles={BIcustomStyles}
              className="form-control selectr"
              placeholder="Select sector type"
              value={selectedSectorType}
              options={sectorTypeData}
              onChange={(e) => setSelctedSectorType(e)}
              isSearchable={true}
              filterOption={customFilter}
              getOptionLabel={(e) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img alt="" style={{ height: 30 }} src={e.icon} />
                  <span
                    style={{
                      marginLeft: 5,
                      fontSize: "var(--text-font-size)",
                    }}
                  >
                    {e.label}
                  </span>
                </div>
              )}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
                // Option: IconOption,
              }}
              isDisabled={
                selectedPermission === "write" || selectedPermission === "admin"
                  ? false
                  : true
              }
            />
          </Form.Group>
          <Form.Group style={{ width: "100%" }}>
            <Form.Label className="bi_details-title">
              Sector Name for Ecosystem <span className="required">*</span>
            </Form.Label>
            <Select
              required
              name="selectedbitype"
              styles={BIcustomStyles}
              className="form-control selectr"
              placeholder="Sector name for ecosystem"
              value={selectedSectorDataForEcosystem}
              options={sectorDataForEcosystem}
              onChange={(e) => setSelectedSectorDataForEcosystem(e)}
              isSearchable={true}
              filterOption={customFilter}
              getOptionLabel={(e) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img alt="" style={{ height: 30 }} src={e.icon} />
                  <span
                    style={{
                      marginLeft: 5,
                      fontSize: "var(--text-font-size)",
                    }}
                  >
                    {e.label}
                  </span>
                </div>
              )}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
                // Option: IconOption,
              }}
              isDisabled={
                selectedPermission === "write" || selectedPermission === "admin"
                  ? false
                  : true
              }
            />
          </Form.Group>
          <Button
            type="button"
            className="save-button-style-rhpo"
            onClick={(e) => handleSubmit(e)}
            disabled={
              selectedPermission === "write" || selectedPermission === "admin"
                ? false
                : true
            }
          >
            Save
          </Button>
        </div>
      </div>
    </motion.div>
  );
};
export default EcMappingAddECSidebar;
